export default __webpack_public_path__ + "static/media/hotel.c5d99eb4.svg";